/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const EDIT_EXPLORE_LINE = gql`
  mutation EditExploreLine($id: ID!, $value: [String]!, $name: String) {
    editExploreLine(id: $id, value: $value, name: $name) {
      id
      name
      property_id
      value
    }
  }
`;
